@if (enabled) {
<aside class="w-12 uppercase c1"
       [class]="customClass"
       [style.color]="style?.textColor || null"
       [style.background-color]="style?.bgColor || null"
       [htmlBinding]="label"></aside>
}